import React from "react";
import styles from "./TransitionChevron.module.scss";
import classNames from "classnames";

/**
 * colors: icon-primary, icon-secondary, icon-tertiary, icon-on-color, disabled
 * the original colors still exist but are deprecated (primary, text, grey, grey-5)
 */
export default React.memo(({isActive, className, style, color, thin, wide, medium}) => {
    return <span className={classNames(styles['base'], className, {[styles[color]]: color, [styles.thin]: thin, [styles.wide]: wide, [styles.medium]: medium})} style={style}>
        <span className={classNames(styles['left'], {[styles['left-active']]: isActive})}/>
        <span className={classNames(styles['right'], {[styles['right-active']]: isActive})}/>
    </span>
});
